module.exports = __webpack_public_path__ + "img/e.b8ad7999.jpg";